// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import Pagination from "../../ResuableCompoment/Pagination";
// import SearchBar from "../../ResuableCompoment/SearchBar";
// import useApi from "../../CustomHooks/useApi";
// import { useSelector } from 'react-redux';

// const OnboardingPending = () => {
//     const [loading, setLoading] = useState(true);
//     const [formsData, setFormsData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rawResponse, setRawResponse] = useState([]);
//     const itemsPerPage = 10;
//     const navigate = useNavigate();

//     const userId = useSelector((state) => state.auth.employeeDetails.userId);

//     const { callApi: pendingOnboard } = useApi(
//         `/staff/onboard/get/half`,
//         "GET"
//     );

//     useEffect(() => {
//         fetchFormsData();
//     }, []);

//     useEffect(() => {
//         console.log("setrawdataa", rawResponse);
//     }, [rawResponse]);

//     const fetchFormsData = async () => {
//         try {
//             const response = await pendingOnboard(null, `?userId=${userId}`);

//             console.log("responceeeee", response);
//             if (response?.length > 0) {
//                 setFormsData(response);
//                 setRawResponse(response);
//             } else {
//                 setFormsData([]);
//             }
//             setLoading(false);
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setLoading(false);
//         }
//     };

//     const filteredForms = formsData.filter(
//         (form) =>
//             form.meta.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             form.mobileNumber.includes(searchQuery) ||
//             form.userId.includes(searchQuery)
//     );

//     return (
//         <div className="min-h-screen p-6 bg-gray-100">
//             <div className="flex items-center mb-6">
//                 <SearchBar
//                     placeholder="Search by Name, Role, or Mobile"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//             </div>

//             <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1 }}
//                 className="bg-white p-8 rounded-lg shadow-2xl"
//             >
//                 <div className="w-full text-black p-4 rounded-lg shadow-2xl text-xl font-semibold text-center mb-4">
//                     <strong>PENDING ONBOARDING</strong>
//                 </div>

//                 {loading ? (
//                     <div className="text-center text-gray-600 text-lg">Loading data...</div>
//                 ) : filteredForms.length === 0 ? (
//                     <div className="text-center text-red-500 text-lg">No data found</div>
//                 ) : (
//                     <Pagination
//                         items={filteredForms}
//                         itemsPerPage={itemsPerPage}
//                         currentPage={currentPage}
//                         onPageChange={setCurrentPage}
//                         renderItems={(currentItems) => (
//                             <div className="overflow-x-auto">
//                                 <table className="min-w-full bg-white border-collapse shadow-xl rounded-lg">
//                                     <thead>
//                                         <tr className="bg-teal-600 text-white text-left text-lg">
//                                             <th className="px-6 py-3 border-b rounded-tl-lg">Name</th>
//                                             <th className="px-6 py-3 border-b">Mobile Number</th>
//                                             <th className="px-6 py-3 border-b">PAN Card</th>
//                                             <th className="px-6 py-3 border-b">Role</th>
//                                             <th className="px-6 py-3 border-b">ID</th>
//                                             <th className="px-6 py-3 border-b">Onboarding Status</th>
//                                             <th className="px-6 py-3 border-b rounded-tr-lg">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {currentItems.map((form, index) => (
//                                             <tr
//                                                 key={index}
//                                                 className="text-gray-800 bg-gray-100 hover:bg-gray-200 transition duration-300"
//                                             >
//                                                 <td className="px-6 py-3 border-b">{form.meta.fullName}</td>
//                                                 <td className="px-6 py-3 border-b">{form.mobileNumber}</td>
//                                                 <td className="px-6 py-3 border-b">{form.panCard}</td>
//                                                 <td className="px-6 py-3 border-b">{form.role}</td>
//                                                 <td className="px-6 py-3 border-b">{form.userId}</td>
//                                                 <td className="px-6 py-3 border-b">{form.meta.Onboarding_status}</td>
//                                                 <td className="px-6 py-3 border-b">
//                                                     <button
//                                                         onClick={() =>
//                                                             navigate("/OnboardingBasicDetails", {
//                                                                 state: {
//                                                                     form: rawResponse.find(
//                                                                         (item) => item.mobileNumber === form.mobileNumber
//                                                                     ),
//                                                                 },
//                                                             })
//                                                         }
//                                                         className="px-5 py-2 bg-green-600 text-white rounded-lg shadow-md hover:bg-green-700 hover:scale-105 transition transform duration-300"
//                                                     >
//                                                         Open
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}
//                     />
//                 )}
//             </motion.div>
//         </div>
//     );
// };

// export default OnboardingPending;

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../../ResuableCompoment/Pagination";
import SearchBar from "../../ResuableCompoment/SearchBar";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const OnboardingPending = () => {
  const [loading, setLoading] = useState(true);
  const [formsData, setFormsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rawResponse, setRawResponse] = useState([]);

  const itemsPerPage = 10;
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.employeeDetails.userId);

  const { callApi: pendingOnboard } = useApi(
    `/staff/onboard/get/half`,
    "GET"
  );

  useEffect(() => {
    fetchFormsData();
  }, []);

  const fetchFormsData = async () => {
    try {
      const response = await pendingOnboard(null, `?userId=${userId}`);
      if (response?.length > 0) {
        setFormsData(response);
        setRawResponse(response);
      } else {
        setFormsData([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredForms = formsData.filter(
    (form) =>
      form.meta.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.mobileNumber.includes(searchQuery) ||
      form.userId.includes(searchQuery)
  );

  return (
    <div className="min-h-screen bg-[#EEF1F5] p-6">
      {/* Search */}
      <div className="mb-6">
        <SearchBar
          placeholder="Search by Name, Role, Mobile or ID"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-xl shadow-md p-6"
      >
        {/* Heading */}
        <div className="mb-6 text-center">
          <h2 className="text-lg font-semibold text-[#0A2A4F]">
            Pending Onboarding
          </h2>
          <p className="text-sm text-slate-500">
            Merchants with incomplete onboarding
          </p>
        </div>

        {loading ? (
          <div className="text-center text-slate-500">Loading data...</div>
        ) : filteredForms.length === 0 ? (
          <div className="text-center text-red-500">No data found</div>
        ) : (
          <Pagination
            items={filteredForms}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            renderItems={(currentItems) => (
              <div className="overflow-x-auto">
                <table className="min-w-full border-separate border-spacing-y-3">
                  <thead className="bg-[#0A2A4F] text-white">
                    <tr className="text-left text-sm">
                      <th className="px-4">Name</th>
                      <th className="px-4">Mobile</th>
                      <th className="px-4">PAN</th>
                      <th className="px-4">Role</th>
                      <th className="px-4">User ID</th>
                      <th className="px-4">Status</th>
                      <th className="px-4 text-right">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((form, index) => (
                      <tr
                        key={index}
                        className="bg-white rounded-lg shadow-sm hover:shadow-md transition"
                      >
                        <td className="px-4 py-3 rounded-l-lg font-medium text-slate-800">
                          {form.meta.fullName}
                        </td>
                        <td className="px-4 py-3 text-slate-700">
                          {form.mobileNumber}
                        </td>
                        <td className="px-4 py-3 text-slate-700">
                          {form.panCard}
                        </td>
                        <td className="px-4 py-3 text-slate-700">
                          {form.role}
                        </td>
                        <td className="px-4 py-3 text-slate-700">
                          {form.userId}
                        </td>
                        <td className="px-4 py-3 text-slate-600">
                          {form.meta.Onboarding_status}
                        </td>
                        <td className="px-4 py-3 rounded-r-lg text-right">
                          <button
                            onClick={() =>
                              navigate("/OnboardingBasicDetails", {
                                state: {
                                  form: rawResponse.find(
                                    (item) =>
                                      item.mobileNumber === form.mobileNumber
                                  ),
                                },
                              })
                            }
                            className="px-4 py-2 text-sm rounded-lg border border-[#0A2A4F] text-[#0A2A4F] hover:bg-[#0A2A4F] hover:text-white transition"
                          >
                            Open
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          />
        )}
      </motion.div>
    </div>
  );
};

export default OnboardingPending;

